export default __webpack_public_path__ + "static/media/100_19598.d6697799.jpg";